export default __webpack_public_path__ + "static/media/2507232.e45f0b1b.jpg";